<section>
  <div class="border_container">
    <div class="col container-style p-2">
      <div class="col py-1 px-2 mb-2">
        <form [formGroup]="formProviderNote">
          <div class="row">
            <div class="col field-prefix">
              <app-custom-input-text formControlName="prefix" [labelText]="'Prefijo'"></app-custom-input-text>
            </div>
            <div class="col field-note-number">
              <app-custom-input-number formControlName="noteNumber" [labelText]="'Número Nota'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-buttons d-flex align-items-end mt-2">
              <app-custom-button [label]="'Actualizar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledActions" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col d-flex justify-content-end mt-3">
      <app-custom-button [label]="'Salir'" [severity]="'danger'" [variant]="undefined"
        (onClick)="close()"></app-custom-button>
    </div>
  </div>
</section>